import React, { memo, useCallback } from 'react';
import { format, parseISO } from 'date-fns';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import SectionHeader from 'design-system/SectionHeader';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounce from 'utils/packages/TouchableBounce';
const PastRatings = ({ selectedDate, analystRatingsDetails, handlePress }) => {
    const styles = useStyles(styleSet);
    const onSelectDate = useCallback((date) => () => {
        handlePress(date);
    }, [handlePress]);
    return (<>
      <SectionHeader>Past ratings</SectionHeader>
      <Spacer h={20}/>
      <View style={styles.row}>
        {analystRatingsDetails.map((eachDetail) => (<TouchableBounce key={eachDetail.date} style={styles.flex} onPress={onSelectDate(eachDetail)}>
            <View style={styles.eachMonthDetail}>
              <View style={styles.progressContainer}>
                {!!eachDetail.data?.buyPercent && (<View style={[styles.buyView, { flex: eachDetail.data?.buyPercent }]}/>)}
                {!!eachDetail.data?.holdPercent && (<View style={[styles.holdView, { flex: eachDetail.data?.holdPercent }]}/>)}
                {!!eachDetail.data?.sellPercent && (<View style={[styles.sellView, { flex: eachDetail.data?.sellPercent }]}/>)}
              </View>
              <Spacer h={8}/>
              <View style={[styles.dateContainer, selectedDate === eachDetail.date && styles.selectedDateContainer]}>
                <Text TextThin-14 Secondary>
                  {format(parseISO(eachDetail.date), 'MMM')}
                </Text>
              </View>
            </View>
          </TouchableBounce>))}
      </View>
    </>);
};
export default memo(PastRatings);
const styleSet = createStyleSheets((colors) => ({
    flex: {
        flex: 1,
    },
    row: {
        flexDirection: 'row-reverse',
    },
    eachMonthDetail: {
        flex: 1,
        alignItems: 'center',
    },
    progressContainer: {
        width: rem(8),
        height: rem(76),
        borderRadius: rem(20),
        paddingVertical: rem(1),
        paddingHorizontal: rem(2),
        backgroundColor: colors.background.dark,
    },
    buyView: {
        width: '100%',
        marginVertical: rem(1),
        borderRadius: rem(16),
        backgroundColor: colors.status.positive,
    },
    holdView: {
        width: '100%',
        marginVertical: rem(1),
        borderRadius: rem(16),
        backgroundColor: colors.text.tertiary,
    },
    sellView: {
        width: '100%',
        marginVertical: rem(1),
        borderRadius: rem(16),
        backgroundColor: colors.elements.statusNegative,
    },
    dateContainer: {
        width: '100%',
        alignItems: 'center',
        paddingVertical: rem(2),
    },
    selectedDateContainer: {
        borderRadius: rem(4),
        backgroundColor: colors.background.dark,
    },
}));
